<div class="panel flex-row flex-wrap mb-0" style="gap: 1rem 5rem;">
	<h4 data-testid="SUBSYS5_PLANHEADER_PATIENT_TXT" class="wrapper-title-span">
		{{ labels().PLAN_HEADER_COMPONENT_PATIENT_ID }}:
		<span>
			@if (hasPatientLink()) {
			<a data-testid="SUBSYS5_PLANHEADER_PATIENT_BTN" href="" onclick="return false;" (click)="goToPatient()">
				{{ plan()?.patient?.number }}
			</a>
			} @else {
			{{ plan()?.patient?.number }}
			}
		</span>
	</h4>

	<h4 data-testid="SUBSYS5_PLANHEADER_PLAN_TXT" class="wrapper-title-span">
		{{ labels().PLAN_HEADER_COMPONENT_PLAN_ID }}: <span>{{ plan()?.number }}</span>
	</h4>
	<h4 data-testid="SUBSYS5_PLANHEADER_TYPE_TXT" class="wrapper-title-span">
		{{ labels().PLAN_HEADER_COMPONENT_PLAN_TYPE }}: <span>{{ plan()?.type | planTypeLabel }}</span>
	</h4>
	<h4 data-testid="SUBSYS5_PLANHEADER_BONE_TXT" class="wrapper-title-span">
		{{ labels().PLAN_HEADER_COMPONENT_PLAN_BONE }}: <span>{{ plan()?.boneType | boneTypeLabel }}</span>
	</h4>
	<h4 data-testid="SUBSYS5_PLANHEADER_SIDE_TXT" class="wrapper-title-span">
		{{ labels().PLAN_HEADER_COMPONENT_PLAN_SIDE }}: <span>{{ plan()?.side | anatomicalSideLabel }}</span>
	</h4>
</div>